import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'

const GalleryComponent = (gallery) => {

    const [show, setShow] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [direction, setDirection] = useState('next');
    const [touchStartX, setTouchStartX] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = () => { setActiveIndex(0); setDirection('next'); setShow(true); };

    const slides = gallery.gallery || [];
    const goPrev = () => { setDirection('prev'); setActiveIndex((i) => (i - 1 + slides.length) % slides.length); };
    const goNext = () => { setDirection('next'); setActiveIndex((i) => (i + 1) % slides.length); };

    const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
    const handleTouchEnd = (e) => {
        if (touchStartX === null) return;
        const delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 40) {
            if (delta < 0) goNext();
            else goPrev();
        }
        setTouchStartX(null);
    };

    useEffect(() => {
        if (!show || slides.length < 2) return undefined;
        const handleKey = (e) => {
            if (e.key === 'ArrowLeft') goPrev();
            else if (e.key === 'ArrowRight') goNext();
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [show, slides.length]);

    const canGalleryRender = gallery.gallery[0];
    if (!canGalleryRender) {
      return null ;
    }
    return (
      <>
        <div className="sl_gallery" onClick={handleShow} onKeyDown={handleShow}>
            {/*If less than three images in the gallery*/}
            { gallery.gallery.length < 3 ? 
            <>
                <div className="sl_gallery__container sl_gallery__container--single">
                    <div className="sl_gallery__image" style={{ backgroundImage: `url(${gallery.gallery[0].asset.url})`}}></div>
                </div>
            </>
            //If three or more images in the gallery
            : gallery.gallery.length >= 3 ? 
            <>
                <div className="sl_gallery__container sl_gallery__container--grid">
                    <div className="sl_gallery__image" style={{ backgroundImage: `url(${gallery.gallery[0].asset.url})`}}></div>
                </div>
                <div className="sl_gallery__container sl_gallery__container--grid">
                    <div className="sl_gallery__image" style={{ backgroundImage: `url(${gallery.gallery[1].asset.url})`}}></div>
                </div>
                <div className="sl_gallery__container sl_gallery__container--grid">
                    <div className="sl_gallery__image" style={{ backgroundImage: `url(${gallery.gallery[2].asset.url})`}}></div>
                </div>
            </>
            : null
            }
        </div>

        <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        dialogClassName="sl_modal sl_modal--gallery"
        contentClassName="sl_modal__content"
        centered 
        >
            <Modal.Body onClick={handleClose}>
                <div
                    className="sl_gallery__slider"
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                >
                    <div className={`sl_gallery__slider__slide sl_gallery__slider__slide--${direction}`}>
                        { slides[activeIndex] && (
                            <img
                                key={`Slide-${activeIndex}-${direction}`}
                                src={slides[activeIndex].asset.url}
                                alt={slides[activeIndex].alt}
                                onClick={(e) => e.stopPropagation()}
                            />
                        )}
                    </div>
                    { slides.length > 1 && (
                        <>
                            <div
                                className="sl_gallery__slider__arrow sl_gallery__slider__arrow--prev"
                                onClick={(e) => { e.stopPropagation(); goPrev(); }}
                                onKeyDown={goPrev}
                                role="button"
                                tabIndex={0}
                            >
                                <i className="fas fa-chevron-left"></i>
                            </div>
                            <div
                                className="sl_gallery__slider__arrow sl_gallery__slider__arrow--next"
                                onClick={(e) => { e.stopPropagation(); goNext(); }}
                                onKeyDown={goNext}
                                role="button"
                                tabIndex={0}
                            >
                                <i className="fas fa-chevron-right"></i>
                            </div>
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>
      </>
    );
};

export default GalleryComponent;